(() => {
  const normalize = value => value.normalize('NFD').replace(/\p{Diacritic}/gu, '').toLocaleLowerCase('de').trim();
  const init = () => {
    document.querySelectorAll('[data-ct-index]:not([data-ct-ready])').forEach(root => {
      root.dataset.ctReady = 'true';
      const form = root.querySelector('[data-ct-filters]');
      const input = root.querySelector('[data-ct-search]');
      const category = root.querySelector('[data-ct-category]');
      const cards = [...root.querySelectorAll('[data-ct-card]')];
      const count = root.querySelector('[data-ct-count]');
      const label = count.textContent.replace(/^\s*\d+\s*/, '');
      const filter = () => {
        const words = normalize(input.value).split(/\s+/).filter(Boolean);
        let visible = 0;
        cards.forEach(card => {
          card.hidden = !(words.every(word => normalize(card.dataset.search).includes(word)) && (!category.value || card.dataset.category.split(' ').includes(category.value)));
          if (!card.hidden) visible++;
        });
        count.textContent = `${visible} ${label}`;
        root.querySelector('[data-ct-empty]').hidden = visible > 0;
      };
      form.hidden = false;
      form.addEventListener('submit', event => event.preventDefault());
      form.addEventListener('input', filter);
      form.addEventListener('change', filter);
      form.addEventListener('reset', () => requestAnimationFrame(filter));
    });
    document.querySelectorAll('[data-ct-recipe]:not([data-ct-ready])').forEach(root => {
      root.dataset.ctReady = 'true';
      const imageChoices = [...root.querySelectorAll('[data-ct-print-image-toggle]')];
      imageChoices.forEach(choice => choice.addEventListener('change', () => {
        root.dataset.ctPrintImage = String(choice.checked);
        imageChoices.forEach(other => { other.checked = choice.checked; });
      }));
      root.dataset.ctPrintImage = 'false';
      const printRecipe = async () => {
        const image = root.querySelector('.ct-hero-image');
        if (root.dataset.ctPrintImage === 'true' && image) {
          try { await image.decode(); } catch {}
        }
        window.print();
      };
      const print = root.querySelector('[data-ct-print]');
      print.hidden = false;
      print.addEventListener('click', printRecipe);
      const preview = root.querySelector('[data-ct-preview]');
      const printStyles = document.querySelector('[data-ct-print-styles]');
      preview.hidden = false;
      const closePreview = () => {
        printStyles.media = 'print';
        document.documentElement.classList.remove('ct-print-preview');
        preview.focus();
      };
      preview.addEventListener('click', () => {
        printStyles.media = 'all';
        document.documentElement.classList.add('ct-print-preview');
        root.querySelector('[data-ct-preview-close]').focus();
        root.scrollIntoView({block:'start'});
      });
      root.querySelector('[data-ct-preview-close]').addEventListener('click', closePreview);
      root.querySelector('[data-ct-preview-print]').addEventListener('click', printRecipe);
      root.addEventListener('keydown', event => { if (event.key === 'Escape' && document.documentElement.classList.contains('ct-print-preview')) closePreview(); });
      const body = root.querySelector('[data-ct-body]');
      let ingredients = false;
      let anchored = false;
      const candidates = [];
      [...body.children].forEach(node => {
        if (/^H[23]$/.test(node.tagName)) {
          if (/zutaten/i.test(node.textContent)) {
            ingredients = true;
            if (!anchored) { body.removeAttribute('id'); node.id = 'ct-ingredients'; anchored = true; }
          } else if (node.tagName === 'H2' || /zubereit|vorbereit|servier/i.test(node.textContent)) ingredients = false;
        } else if (ingredients && node.tagName === 'P') {
          const lines = node.innerHTML.split(/<br\s*\/?\s*>/i);
          if (lines.length > 1) {
            node.replaceChildren(...lines.map(html => {
              const span = document.createElement('span');
              span.className = 'ct-checkline';
              span.innerHTML = html;
              candidates.push(span);
              return span;
            }));
          } else candidates.push(node);
        } else if (ingredients && node.tagName === 'UL') candidates.push(...node.querySelectorAll(':scope > li'));
      });
      if (!anchored) root.querySelector('a[href="#ct-ingredients"]')?.remove();
      const toggle = root.querySelector('[data-ct-check-toggle]');
      const tools = root.querySelector('[data-ct-tools]');
      tools.hidden = candidates.length === 0;
      candidates.forEach((node, index) => {
        const box = document.createElement('input');
        box.type = 'checkbox';
        box.className = 'ct-ingredient-check';
        box.setAttribute('aria-label', node.textContent.trim());
        box.hidden = true;
        box.id = `ct-ingredient-${index}`;
        box.addEventListener('change', () => node.classList.toggle('ct-checked', box.checked));
        node.prepend(box);
      });
      const clear = () => root.querySelectorAll('.ct-ingredient-check').forEach(box => { box.checked = false; box.parentElement.classList.remove('ct-checked'); });
      toggle.addEventListener('change', () => { root.querySelectorAll('.ct-ingredient-check').forEach(box => { box.hidden = !toggle.checked; }); if (!toggle.checked) clear(); });
      root.querySelector('[data-ct-clear]').addEventListener('click', clear);
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();


